import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getSubmissions } from 'store/entities/submissions/thunks';
import { formatDateGlobal } from 'utils/dateUtils';
import { notifyError } from 'utils/notifications';

export default () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { institutionId } = useParams();
  const {
    submissionsListCurrentPage,
    submissionsListPageSize,
    reporter,
    obligation,
    status,
    startDate,
    endDate,
    type,
    institution,
    showAllProblematic,
  } = useSelector(state => state.submissions);
  const { userDetails } = useSelector(state => state.auth);

  const doSearch = value => {
    const searchInput = value ?? obligation;
    if (searchInput.length >= 3 || searchInput === '') {
      const payload = {
        searchInput,
        showAllProblematic,
        ...(startDate ? { startDate: formatDateGlobal(startDate) } : {}),
        ...(endDate ? { endDate: formatDateGlobal(endDate) } : {}),
        ...(reporter
          ? { reporterId: reporter?.value?.publicUserDto?.id }
          : !institutionId
          ? { reporterId: userDetails?.userId }
          : {}),
        ...(institutionId || institution
          ? { institutionId: parseInt(institutionId) || institution?.value?.id }
          : {}),
        ...(status && status?.length > 0 ? { status } : {}),
        obligationFilter: type,
        page: submissionsListCurrentPage,
        size: submissionsListPageSize,
      };
      dispatch(getSubmissions(payload));
    } else
      notifyError(
        t('datagate.external.submissions.filter.obligation.error.length')
      );
  };

  return doSearch;
};
